<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <v-container id="document_signature_customization_root" fluid>
    <implicit-authorization-modal
      :key="implicitAuthorizationModalKey" :signature-guid="implicitGuid" :evro-signature-count="evroSignatureCount"
      :request-loading-dialog-showed="ImplicitAuthorizationModalVisible"
    ></implicit-authorization-modal>
    <!-- header -->
    <v-row class="mb-6 px-6" justify="center" align="center">
      <v-btn id="back_button" class="elevation-0 pl-0 pr-3" color="black--text grey lighten-2" @click="back">
        <v-icon class="ma-0 pa-0" color="grey darken-5">
          mdi-chevron-left
        </v-icon>
        {{ $t('main.back') }}
      </v-btn>
      <v-col cols="7">
        <span class="text-h5">
          {{ currentDocument.fileName }}</span>
      </v-col>

      <v-col class="d-flex flex-row justify-end 2">
        <v-btn
          id="signature_confirmation_sign_btn" color="success" tabindex="2"
          :loading="authorizationModalBtnLoading || isUploading" :disabled="!isFormValid" @click=" (isImplicitCredential(selectedCredential) || isOAUTH2CODECredential(selectedCredential) || isSealSignMode() || isCredentialUnknownAuthMode(selectedCredential))
            ? signDoc()
            : showAuthorizationModal()"
        >
          <v-icon class="mr-1 ml-0">mdi-draw-pen</v-icon>

          {{ $t('documentSignatureCustomization.content.signature.multipleSign.signAllBtn') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="stretch" align-content="space-between">
      <v-col md="6" sm="12" align="start">
        <!-- SIGNATURE + CRED  CONFIG-->
        <v-card>
          <v-container class="d-flex flex-column">
            <v-form ref="form" v-model="formValid" @input="handleFormValidityChange">
              <v-row v-show="pdfRendered">
                <v-col>
                  <v-switch
                    id="set_visible_signature" v-model="useVisibleSignature"
                    :label="$t('documentSignatureCustomization.content.signature.setVisibleSignature')"
                    :disabled="sealActivated && (credentialsWithCentralKeyToo.length == 1)" class="mx-3"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="useVisibleSignature" class="mb-4">
                <!--
                <v-btn
                  v-if="!useCustomDrawnSignatureImage && !useSignatureProfile && signatureProfiles.length > 0"
                  id="ChooseSignatureProfile-button" class="ml-3 pa-1 pr-2 body-2 white--text modalButton"
                  @click="useSignatureProfileClick"
                >
                  <v-icon>mdi-form-select</v-icon>
                  {{ $t('documentSignatureCustomization.content.signature.chooseYourSignature') }}
                </v-btn>
                -->
                <v-btn
                  v-if="!useCustomDrawnSignatureImage" id="draw_signature"
                  class="ml-3 pa-1 pr-2 body-2 white--text modalButton" @click="useCustomSignatureClick"
                >
                  <v-icon>mdi-pen</v-icon>
                  {{ $t('signatureDrawer.title') }}
                </v-btn>

                <v-btn
                  v-if="useCustomDrawnSignatureImage" id="clear_drawed_signature"
                  class="ml-3 pa-1 pr-2 body-2 white--text modalButton" @click="clearCutomSignatureImageClick"
                >
                  <v-icon>mdi-refresh</v-icon>
                  {{ $t('documentSignatureCustomization.content.signature.clearCutomSignatureImage') }}
                </v-btn>
              </v-row>
              <v-row v-show="pdfRendered && useVisibleSignature && useSignatureProfile">
                <v-col>
                  <v-divider role="presentation"></v-divider>
                  <v-select
                    id="select_signature_profile" v-model="selectedSignatureProfile" class="mx-3 mt-5 mb-4"
                    :items="signatureProfiles" item-text="name"
                    :label="$t('documentSignatureCustomization.content.signature.selectSignatureProfile') + `*`"
                    :rules="signatureProfileRule"
                    :error-messages="useSignatureProfile ? (credentialAliveError ? [credentialAliveError] : []) : []"
                    return-object
                  ></v-select>

                  <p v-show="showBlueWarning" class="BlueWarning">
                    {{
                      $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}
                  </p>

                  <v-row align="center" class="mx-3 mb-3">
                    <span>{{ $t('documentSignatureCustomization.content.signature.multipleSign.savePostionText')
                    }}</span>
                    <v-btn
                      id="save_position_btn" class="mx-3 pa-1" color="success" outlined
                      :disabled="!checkUniquePosition(currentChain)" @click="saveImagePosToProfileAndApplyAll()"
                    >
                      <v-icon class="mr-1 ml-0">{{ saveImagePostionIcon }}</v-icon>
                      {{ $t('main.save') }}
                    </v-btn>
                  </v-row>

                  <v-switch
                    v-show="credentialsWithCentralKeyToo.length > 0" v-model="useDifferentCredential"
                    :label="$t('documentSignatureCustomization.content.signature.useDifferentCredential')"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-show="!useVisibleSignature || (useVisibleSignature && !useSignatureProfile) || (useVisibleSignature && useSignatureProfile && useDifferentCredential)"
                >
                  <v-divider v-show="pdfRendered" role="presentation"></v-divider>
                  <v-select
                    v-if="credentialsWithCentralKeyToo.length > 0"
                    id="signature_customization_credential_select" v-model="selectedCredential" class="mx-3 mt-5"
                    :items="credentialsWithCentralKeyTooComputed" :item-text="getCredentialItemText"
                    :return-object="true"
                    :label="$t('documentSignatureCustomization.content.signature.selectSigningCredential') + `*`"
                    :rules="selectedCredentialRule" @input="$refs.form.resetValidation()"
                  >
                    <!-- <template v-slot.item="{item}">
                      <div class="option_active_credential">
                        {{ item }}
                      </div>
                    </template> -->
                  </v-select>
                  <p v-show="showBlueWarning" class="BlueWarning">
                    {{
                      $t('documentSignatureCustomization.warning.someCredendetialHaveProblem') }}
                  </p>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card>
        <!-- CHAINS TO SIGN LIST + SELCT -->
        <v-card class="mt-6 pa-4">
          <v-card-subtitle>
            {{ $t('documentSignatureCustomization.content.signature.multipleSign.defaultPositionExplainer') }}
          </v-card-subtitle>
          <v-list shaped>
            <v-list-item-group v-model="currentChain" mandatory @change="downloadDocument(currentChain)">
              <v-list-item v-for="chain in chainsToSign" :key="chain.id" :value="chain">
                <v-list-item-content>
                  <v-list-item-title v-text="chain.origDocument.fileName"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <template v-if="currentChain?.id === chain.id && dragging">
                    <!-- <v-chip> -->
                    <v-progress-circular color="info lighten-2" indeterminate></v-progress-circular>
                    <!-- </v-chip> -->
                  </template>

                  <template v-else>
                    <v-chip v-if="checkUniquePosition(chain)" color="success" outlined>
                      <!-- <v-icon>mdi-border-radius</v-icon> -->
                      <span class="button">{{
                        $t('documentSignatureCustomization.content.signature.multipleSign.uniquePosBadge') }}</span>
                    </v-chip>
                    <v-chip v-else outlinedd>
                      <!-- <v-icon>mdi-border-radius</v-icon> -->
                      <span class="button">{{
                        $t('documentSignatureCustomization.content.signature.multipleSign.defaultPosBadge') }}</span>
                    </v-chip>
                  </template>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <!-- visibleSignatureComponent -->
      <v-col cols="6" md="6" sm="12" align="center" style="position: relative;">
        <div align="center">
          <v-overlay :absolute="true" :value="isUploading">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
          </v-overlay>

          <visibleSignature
            v-for="(chain, index) in chainsToSign" :key="chain.id" ref="visibleSignature"
            :doc-data="visibleSignatures[index]?.docData" :sign-prof="signatureProfileByChainId[chain.id] || selectedSignatureProfile"
            :allow-sign-profile-editing="!hasPredefinedSignatureParams(chain)"
            @updatedSignProf="updatedSignatureProfile" @pdfLoaded="pdfLoaded" @sizingFinished="signatureDropped"
            @draggingFinished="signatureDropped"
          />
        </div>
      </v-col>
    </v-row>
    <!-- authorizationModal -->
    <v-row justify="center">
      <v-dialog v-model="authorizationModal" persistent max-width="500">
        <v-card id="explicit_auth_modal">
          <v-card-title>
            <span class="headline">{{ $t('documentSignatureCustomization.modal.authorization.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="authorizationModalForm" v-model="authorizationModalFormValid" @submit.prevent>
              <v-text-field
                id="explicit_authmodal_textfield" ref="passwordField" v-model="expAuthPwd.pwd" tabindex="1"
                :append-icon="expAuthPwd.showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                :label="$t('documentSignatureCustomization.modal.authorization.content.keyPassword') + `*`"
                :type="expAuthPwd.showPwd ? 'text' : 'password'" prepend-icon="mdi-lock"
                :rules="[rules.required, rules.passwordMustBeLongerThan]"
                @click:append="expAuthPwd.showPwd = !expAuthPwd.showPwd" @keydown.enter="signDoc()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text tabindex="3" @click="authorizationModal = false">{{ $t('main.cancel') }}</v-btn>
            <v-btn
              id="explicit_authmodal_signbtn" color="success" tabindex="2" :disabled="!authorizationModalFormValid"
              :loading="authorizationModalBtnLoading" @click="signDoc()"
            >
              {{ $t('documentSignatureCustomization.modal.authorization.content.button.sign') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noCredentialWarningVisible" persistent width="auto" max-width="700">
        <v-card id="no_credential_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedCredential.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.noActivatedCredential.description') }}
            </div>
            <v-btn
              id="no_credential_warning_ok" style="text-align: center;" color="primary" to="/credentials"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.noActivatedCredential.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="notVerifiedUserWarningVisible" persistent width="auto" max-width="700">
        <v-card id="not_verifiedUser_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.notVerifiedUser.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.notVerifiedUser.description') }}
            </div>
            <v-btn
              id="not_verified_user_warning_ok" style="text-align: center;" color="primary" to="/credentials"
              class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.notVerifiedUser.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="noDeviceForImplicitCredentialWarningVisible" persistent max-width="550">
        <v-card id="no_device_warning" class="pa-6">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.noActivatedDevice.title') }}
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="start">
                <div>
                  {{ $t('signatureProfiles.error.noActivatedDevice.description') }}
                </div>
                <div class="pt-6">
                  <v-btn id="no_device_warning_ok" color="primary" to="/user/profile/" class=" mb-0">
                    <v-icon class="mr-1">mdi-cellphone-key</v-icon>
                    {{ $t('signatureProfiles.error.noActivatedDevice.button') }}
                  </v-btn>
                </div>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible" persistent width="auto"
        max-width="700"
      >
        <v-card id="centralKey_Enabled_And_noProfile_WithCentralKey_warning" class="py-6 px-3">
          <v-card-title class="text-h6 red--text">
            {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.title') }}
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.description') }}
            </div>
            <v-btn
              id="centralKey_Enabled_And_noProfile_WithCentralKey_warning_ok" style="text-align: center;"
              color="primary" to="/signatureProfiles" class="mt-10 mb-0"
            >
              <v-icon class="mr-1">mdi-folder-open-outline</v-icon>
              {{ $t('signatureProfiles.error.centralKeyEnabledAndNoProfileWithCentralKey.button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <pdf-password-modal
        ref="pdfPasswordModal" :visible.sync="isPasswordModalVisible" :pdf-filename="pdfFilename"
        @passwordSpecified="handlePasswordSpecified" @passwordCancelled="handlePasswordCancelled"
      >
      </pdf-password-modal>
    </v-row>

    <v-row>
      <signature-drawer
        ref="signatureDrawer" v-model="showSignatureModal"
        @saved="handleCustomSignature"
        @cancel="handleCustomSignatureCancelled"
      ></signature-drawer>
    </v-row>
  </v-container>
</template>

<script>

import PDFPasswordModal from '@/components/PDFPasswordModal'
import SignatureDrawer from '@/components/SignatureDrawer.vue'
import credentialRefs from '@/services/api/credentialRefs'
import csc from '@/services/api/csc'
import evro from '@/services/api/evro'
import rssp from '@/services/api/rsspUtil.js'
import seal from '@/services/api/seal.js'
import memberRole from '@/views/signature/chains/memberRole'
import { UserManager } from 'oidc-client-ts'
import { v4 as uuidv4 } from 'uuid'
import VisibleSignature from '../../components/VisibleSignature'
import { showConfirmationMenu, showRequestLoadingDialog, showToastError, showToastSuccess } from '../../event-bus'
import documents from '../../services/api/documents'
import signatureProfiles from '../../services/api/signatureProfiles'
import signatures from '../../services/api/signatures'
import userVerification from '../../services/api/userVerification'
import users from '../../services/api/users'
import CommonError from '../CommonError'
import CredentialAuthMode from './CredentialAuthMode'
import ImplicitAuthorizationModal from './ImplicitAuthorizationModal'
import SignatureChainType from './chains/SignatureChainType'

export default {

  components: {
    SignatureDrawer,
    VisibleSignature,
    ImplicitAuthorizationModal,
    'pdf-password-modal': PDFPasswordModal
  },

  data() {
    return {
      formValid: true,
      evroEnabled: this.$store.state.remoteConfig.evroEnabled ? this.$store.state.remoteConfig.evroEnabled : false,
      documentBase64: null,
      currentDocument: {},
      currentChain: null,
      visibleSignatures: [],
      visibleSignatureCoponentsFilled: false,
      pdfRendered: false,
      // useVisibleSignature: false,
      useVisibleSignature: true, // from v1.11 we set this to default true
      useSignatureProfile: false,
      useDifferentCredential: false,
      useCustomDrawnSignatureImage: false,
      userDrawedSignatureImage: null,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      signatureProfiles: [],
      originalSignatureProfiles: [],
      signatureProfilesFilled: false,
      selectedSignatureProfile: {
        credentialId: ''
      },
      activatedCredentials: [],
      credentialRefs: [],
      credentialsEvro: [],
      myCredentials: [],
      providers: null,
      userVerificationImage: null,
      credentialsWithCentralKeyToo: [],
      selectedCredential: null,
      switchSignatureChainType: false,
      draftRecipients: [{ userId: null }],
      authorizationModalFormValid: false,
      authorizationModal: false,
      authorizationModalBtnLoading: false,
      // implicitAuthorizationModal
      implicitAuthorizationModalKey: 0,
      implicitGuid: '',
      evroSignatureCount: 0,
      devicesListTotalItems: 0,
      devicesActiveTotalItems: 0,
      ImplicitAuthorizationModalVisible: false,
      showBlueWarning: false,
      noCredentialWarningVisible: false,
      noDeviceForCredentialWarningVisible: false,
      noDeviceForImplicitCredentialWarningVisible: false,
      notVerifiedUserWarningVisible: false,
      centralKeyEnabledAndnoProfileWithCentralKeyWarningVisible: false,
      authorizationTimeoutMilis: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000 : null,
      evroTrustAuthorizationTimeoutMilis: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.evroAuthorizationTimeoutSecs * 1000 : 60 * 1000,
      showSignatureModal: false,
      documenDtos: [],
      pdfEncrypted: false,
      pdfFilename: null,
      isPasswordModalVisible: false,
      passwordModalResolve: null,
      passwordModalReject: null,
      // centralKeyId: 'central_key_id',
      centralKeyId: -1,
      expAuthPwd: {
        pwd: null,
        showPwd: false
      },
      credentialAliveError: '',
      passwordMinCharacters: 6,
      rules: {
        // required: v => !!v || this.$t('validation.form.requiredField')
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        passwordMustBeLongerThan: v => (v && v.length >= this.passwordMinCharacters) || this.$t('validation.form.passwordMustBeLongerThan', { min: this.passwordMinCharacters }),
        onlyNumber: v => (/^[0-9]+$/.test(v)) || this.$t('validation.form.onlyNumbers'),
        // credentialAlive: (v) => (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === this.selectedSignatureProfile.credentialId) || !!this.selectedCredential.id))) || this.$t('validation.form.credentialIsDead')
        credentialAlive: (v) => {
          this.credentialAliveError = ''
          // if (this.sealEnabled && (!this.useSignatureProfile || (this.selectedCredential && this.selectedCredential.id === this.centralKeyId))) {
          if (this.sealActivated) {
            // profil, nem másik jog használata
            if (this.useSignatureProfile && !this.useDifferentCredential && this.selectedSignatureProfile.useSeal) {
              const res = this.sealActivated || this.$t('validation.form.centralKeyIsNotActivated')
              this.credentialAliveError = typeof res === 'boolean' ? '' : res
              return res
            } else
            // todo rewrite to credref
            // if ((this.useSignatureProfile || (this.selectedCredential && this.selectedCredential.id))) {
            if (this.useSignatureProfile) {
              const profileCredFoundInActivated = !!(this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedSignatureProfile.credentialId)))
              const credFoundInActivated = this.selectedCredential && !!(this.activatedCredentials.find(cred => cred.id === this.selectedCredential.id))
              if (this.selectedSignatureProfile.useSeal && this.useDifferentCredential && (!this.selectedCredential || (!this.selectedCredential.id && !this.selectedCredential.credentialRefId && !this.selectedCredential.isEvro))) {
                return true
              }
              if (this.useSignatureProfile && this.useDifferentCredential && (this.selectedCredential && (this.selectedCredential.id === -1))) {
                return true
              }
              const res = ((this.useSignatureProfile && profileCredFoundInActivated) || (this.useSignatureProfile && this.useDifferentCredential && credFoundInActivated) || (!this.useSignatureProfile && credFoundInActivated && !!this.selectedCredential.id) || (this.selectedCredential && this.selectedCredential.provider) || (this.selectedCredential && this.selectedCredential.isEvro))
              this.credentialAliveError = typeof res === 'boolean' ? '' : res
              return (!!res) || this.$t('validation.form.credentialIsDead')
              // return true
            }
            this.credentialAliveError = ''
            return true
          } else {
            // console.log('credentialAlive 2 this.selectedSignatureProfile', this.selectedSignatureProfile)
            // console.log('credentialAlive 2 this.selectedCredential', this.selectedCredential)
            // todo rewrite to credref
            // return (!!this.selectedCredential && (!!this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedSignatureProfile.credentialId)) || !!this.selectedCredential.id)) || this.$t('validation.form.credentialIsDead')
            const res = (!!(!!this.selectedCredential && (this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedSignatureProfile.credentialId)) || !!this.selectedCredential.id))) || (this.selectedCredential && this.selectedCredential.provider) || (this.selectedCredential && this.selectedCredential.isEvro) || this.$t('validation.form.credentialIsDead')
            this.credentialAliveError = typeof res === 'boolean' ? '' : res
            // console.log('credentialAlive res', res)
            return res
            // return true
          }
        }
      },

      isUploading: true,
      abortController: null,
      // decline reasoning:
      declineReasonVisible: false,
      // save image postion :
      saveImagePostionIcon: 'mdi-content-save-outline',
      signatureProfileMoved: false,
      dragging: false,
      signatureProfileBackup: null,
      defaultPosition: {},
      needsDefaultPos: false,
      initialProfileAlreadySelected: false,
      signatureProfileByChainId: {},
      popupLoginWidth: this.$store.state.remoteConfig.popupLogin?.width ?? 770,
      popupLoginHeight: this.$store.state.remoteConfig.popupLogin?.height ?? 720
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },
    readyToSign() {
      return this.chainsToSign.every(x => !!x.signatureFieldParameters)
    },
    // from validating not working correctly on this page, so made this not so nice hack. todo: fix the validation issues
    isFormValid() {
      const isSigner = this.hasRoleInternal(memberRole.SIGNER.toLowerCase())
      if (!isSigner) {
        return false
      }
      // const noSignatureProfileUsedError = !this.useSignatureProfile && (!this.sealActivated || ((this.selectedCredential === null) || (!this.selectedCredential.id)))
      // let sealConditions = true
      let noSignatureProfileUsedError = !this.useSignatureProfile && ((!this.selectedCredential) || (!this.selectedCredential.id && !this.selectedCredential.credentialRefId && !this.selectedCredential.isEvro))
      if (this.sealActivated && !this.useSignatureProfile && (!this.selectedCredential || !this.selectedCredential.id)) {
        return false
      }
      if (!this.useSignatureProfile && this.sealActivated) {
        noSignatureProfileUsedError = false
      }
      if (this.useSignatureProfile && this.useDifferentCredential && this.selectedCredential && (this.selectedCredential.id || this.selectedCredential.credentialRefId || this.selectedCredential.isEvro)) {
        return true
      }

      if (!this.useSignatureProfile && this.useVisibleSignature && !this.userDrawedSignatureImage) {
        return false
      }

      // const SignatureProfileUsedError = this.useSignatureProfile && ((this.selectedSignatureProfile === null) || (!this.selectedSignatureProfile.credentialId))
      const SignatureProfileUsedError = this.useSignatureProfile && (!this.selectedSignatureProfile || !(this.selectedSignatureProfile.credentialRefId || this.selectedSignatureProfile.evroRefId || this.selectedSignatureProfile.credentialId || this.selectedSignatureProfile.useSeal))
      const SignatureProfileUsedAndDifferentCredentialError = this.useSignatureProfile && this.useDifferentCredential && ((!this.selectedCredential) || !(this.selectedCredential.credentialRefId || this.selectedCredential.isEvro || this.selectedCredential.credentialId))

      /* console.log('this.useSignatureProfile', this.useSignatureProfile)
      console.log('isFormValid SignatureProfileUsedAndDifferentCredentialError', SignatureProfileUsedAndDifferentCredentialError) */

      const selectedCredIsImplicit = this.selectedCredential && this.isImplicitCredential(this.selectedCredential)
      const implicitValid = !selectedCredIsImplicit || (selectedCredIsImplicit && (this.devicesActiveTotalItems > 0))
      const formValidRes = this.formValid
      // formValidRes = true // todo: harcoded workaround because formValid returns false even when no error exist for the form
      const res = formValidRes && implicitValid && (this.isSealSignMode() || (!noSignatureProfileUsedError && !SignatureProfileUsedError && !SignatureProfileUsedAndDifferentCredentialError))
      // const res = !noSignatureProfileUsedError && !SignatureProfileUsedError
      return res
    },

    signatureProfileRule() {
      const rulesArray = []
      if (this.useSignatureProfile) {
        rulesArray.unshift(this.rules.credentialAlive)
        rulesArray.unshift(this.rules.required)
      }
      return rulesArray
    },

    selectedCredentialRule() {
      // const rulesArray = [this.rules.required]
      const rulesArray = []
      // if (!useSignatureProfile || (useSignatureProfile && useDifferentCredential)) {
      if (this.useDifferentCredential) {
        rulesArray.unshift(this.rules.required)
      }

      return rulesArray
    },

    sealActivated() {
      return this.sealStatus.enabled && this.sealStatus.activated
    },

    sealEnabled() {
      return this.sealStatus.enabled
    },
    chainsToSign() {
      return this.$store.state.chainsToSign
      // return [...this.$store.state.chainsToSign]
    },
    isVerificationEnabled() {
      return !!this.$store.state.remoteConfig.regulaEnabled
    },
    credentialsWithCentralKeyTooComputed() {
      return this.credentialsWithCentralKeyToo.map((item, index) => {
        if (this.sealActivated) {
          const centralKeyDisabled = (this.sealActivated && !this.useVisibleSignature) || (this.useDifferentCredential && this.useSignatureProfile && (this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal))
          if (index === 0 && centralKeyDisabled) {
            return {
              ...item,
              disabled: true
            }
          }
          return item
        } else {
          return item
        }
      })
    }
  },

  watch: {
    /* chainsToSign(newVal) {
      const changedValueCopied = { ...newVal }
    }, */
    selectedSignatureProfile(newVal, oldVal) {
      this.updateSignatureProfileForVisibleSignatureComponents()

      if (!newVal) {
        this.selectedCredential = {}

        return
      }

      const applyDefaultPositions = (signProfile) => {
        if (this.chainsToSign) {
          this.chainsToSign.forEach(x => {
            const profile = this.buildSignatureProfileForChain(x, signProfile)
            x.signatureFieldParameters = profile
          })
        }
      }
      if (newVal?.id !== oldVal?.id) {
        if (!newVal?.savedSignatureFieldParameters) {
          newVal.savedSignatureFieldParameters = {
            originX: 0,
            originY: 0
          }
        }
        applyDefaultPositions(newVal)
        this.defaultPosition = this.getObjectDuplicate(newVal.savedSignatureFieldParameters)
      }
      if (newVal.credentialRefId || newVal.evroRefId || newVal.credentialId) {
        if (this.sealEnabled && (newVal.useSeal)) {
          if (!this.selectedCredential) {
            this.selectedCredential = {}
          }
          this.selectedCredential.id = parseInt(newVal.credentialRefId)
          this.checkFormValidity()
        } else {
          if (newVal.credentialRefId) {
            // JSON.parse(JSON.stringify(newVal))
            this.selectedCredential = this.findCredentialByRefId(parseInt(newVal.credentialRefId))
            // this.selectedCredential = JSON.parse(JSON.stringify(this.findCredentialByRefId(parseInt(newVal.credentialRefId))))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(newVal.credentialRefId)
            }
          } else
          if (newVal.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(parseInt(newVal.evroRefId))
            // this.selectedCredential = JSON.parse(JSON.stringify(this.findCredentialByEvroRefId(parseInt(newVal.evroRefId))))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              this.selectedCredential.id = parseInt(newVal.evroRefId)
              this.selectedCredential.isEvro = true
            }
          } else {
            this.selectedCredential = this.findCredentialById(parseInt(newVal.credentialId))
            // this.selectedCredential = JSON.parse(JSON.stringify(this.findCredentialById(parseInt(newVal.credentialId))))
            if (this.selectedCredential === undefined || !this.selectedCredential) {
              this.selectedCredential = {}
              // don't add id, probably dead cread if we didn't find it
              // this.selectedCredential.id = parseInt(newVal.credentialId)
            }
          }
          if (!this.selectedCredential) {
            // probably dead cred
            this.selectedCredential = {}
            this.selectedCredential.id = undefined
          }
          this.$refs.form.validate()
          this.$refs.form.resetValidation()
        }
      } else {
        if (!this.sealEnabled) {
        }

        this.selectedCredential = {}
        if (this.selectedSignatureProfile.useSeal) {
          this.selectedCredential.id = this.centralKeyId
        }
      }
      if (this.useVisibleSignature && this.useSignatureProfile && !this.selectedSignatureProfile.sourceImageDataUrl) {
        signatures.getVisibleSignature(this.selectedSignatureProfile.id)
          .then(visResp => {
            this.selectedSignatureProfile.sourceImageDataUrl = visResp.data.imageDataUrl
            this.$nextTick(() => {
              this.updateSignatureProfileForVisibleSignatureComponents()

              this.chainsToSign.forEach(x => {
                const signature = this.$refs.visibleSignature[x]
                signature.updateSignatureProfile(
                  this.signatureProfileByChainId[this.chainsToSign[x].id] || this.selectedSignatureProfile
                )
              })
            })
          })
      }
    },
    async selectedCredential(val) {
      if (val && val.provider) {
        const credInfo = await this.getCredentialInfosWithCSC()
      }
      this.$refs.form.validate()
      this.checkFormValidity()
    },
    useDifferentCredential(val) {
      if (!val) {
        if (!this.useSignatureProfile) {
          this.selectedCredential = {}
        } else
        if (this.selectedSignatureProfile) {
          if (this.selectedSignatureProfile.credentialRefId) {
            this.selectedCredential = this.findCredentialByRefId(parseInt(this.selectedSignatureProfile.credentialRefId))
            const credInfo = this.getCredentialInfosWithCSC()
          } else
          if (this.selectedSignatureProfile.evroRefId) {
            this.selectedCredential = this.findCredentialByEvroRefId(parseInt(this.selectedSignatureProfile.evroRefId))
          } else {
            this.selectedCredential = this.findCredentialById(parseInt(this.selectedSignatureProfile.credentialId))
          }
        }
        if (this.sealActivated && (this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal)) {
          this.selectedCredential = this.findCredentialById(-1)
        }
      } else {
        this.selectedCredential = undefined
      }

      // this.$refs.form.resetValidation()
      this.$refs.form.validate()
    },

    useSignatureProfile(val) {
      if (val) {
        // this.selectedCredential = {}
      } else {
        this.selectedSignatureProfile = {}
      }
      this.$refs.form.resetValidation()
    },
    async useVisibleSignature(val) {
      if (val) {
        if (this.signatureProfiles.length > 0) {
          this.useSignatureProfile = true
          this.selectedSignatureProfile = this.signatureProfiles[0]
        }
        this.useSignatureProfile = !this.useCustomDrawnSignatureImage && !this.useSignatureProfile && this.signatureProfiles.length > 0
        this.useCustomDrawnSignatureImage = false
        this.userDrawedSignatureImage = null
      } else {
        this.useSignatureProfile = false
        this.selectedSignatureProfile = null
        this.useCustomDrawnSignatureImage = false
        this.userDrawedSignatureImage = null
      }
      this.useDifferentCredential = false
      if (!val) {
        this.useSignatureProfile = false
      } else {
        this.selectFirstProfile()
      }
      this.$refs.form.resetValidation()
    },
    async currentChain(val) {
      if (!this.signatureProfilesFilled) {
        await this.getSignatureProfiles()
      }

      if (!this.visibleSignatureCoponentsFilled) {
        await this.initVisibleSignatureComponents()
      }

      // Hide all visibleSignatures
      this.visibleSignatures.forEach(signature => { signature.$el.style.display = 'none' })
      // Show the active visibleSignature
      if (val !== null) {
        const activeIndex = this.chainsToSign.findIndex(chain => chain.id === val.id)
        if (activeIndex !== -1 && this.visibleSignatures[activeIndex]) {
          const activeSignature = this.visibleSignatures[activeIndex]
          if (!activeSignature.docData) {
            // Download document and assign base64 string to docData property
            const base64Data = await this.downloadDocument(this.chainsToSign[activeIndex])
            activeSignature.updateEncryptionStatus((this.currentDocument.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (this.currentDocument.security === 'ENCRYPTED_WITH_USER_PASSWORD'))
            // activeSignature.docData = base64Data
            this.$set(activeSignature, 'docData', base64Data)
          }
          if (!this.signatureProfileByChainId[val.id]) {
            this.$set(this.signatureProfileByChainId, val.id, this.buildSignatureProfileForChain(val))
          }
          if (!activeSignature.signProf) {
            this.$set(activeSignature, 'signProf', this.signatureProfileByChainId[val.id] || this.selectedSignatureProfile)
          }
          activeSignature.$el.style.display = 'block'
          activeSignature.redrawEverything()

          this.isUploading = false
        }
      }

      // this.downloadDocument(val)

      const profileParams = val.signatureFieldParameters

      if (profileParams) {
        // this.signatureProfileBackup = profileParams
        this.signatureProfileBackup = this.getObjectDuplicate(profileParams)
      } else {
        this.signatureProfileBackup = this.getObjectDuplicate(this.selectedSignatureProfile)
        if (this.needsDefaultPos) {
          this.signatureProfileBackup.savedSignatureFieldParameters = {}
          this.signatureProfileBackup.savedSignatureFieldParameters.originX = 0
          this.signatureProfileBackup.savedSignatureFieldParameters.originY = 0
        }
      }
      // delete this.selectedSignatureProfile.savedSignatureFieldParameters
      this.signatureProfileMoved = false
    }
  },

  async mounted() {
    if (!this.chainsToSign) {
      this.back()
      return
    }
    if (!this.signatureProfilesFilled) {
      await this.getSignatureProfiles()
    }

    if (!this.visibleSignatureCoponentsFilled) {
      this.initVisibleSignatureComponents()
    }

    // await this.downloadDocument(this.$store.state.chainsToSign[0])

    this.sealStatus = await seal.getSealStatus()

    this.user = await users.getMyUser()

    await this.listMyActivatedCredentials()

    await this.listImportedCredentials()

    this.credentialsWithCentralKeyToo = [...this.activatedCredentials, ...this.credentialRefs, ...this.credentialsEvro]

    if (this.sealActivated) {
      this.credentialsWithCentralKeyToo.unshift({ id: -1, description: this.$t('documentSignatureCustomization.content.signature.centralKey') })
      /* if (this.credentialsWithCentralKeyToo.length === 1) {
        this.useVisibleSignature = true
      } */
    }

    this.selectFirstProfile()

    // this.user.verified = true // todo remove in production
    this.notVerifiedUserWarningVisible = this.isVerificationEnabled && this.user && this.user.verificationMandatory && !this.user.verified

    if (this.isVerificationEnabled) {
      this.getVerificationDetails()
    }

    this.providers = await credentialRefs.getExternalProviders('web')

    await this.handleWarning()
    this.abortController = new AbortController()

    if (this.sealActivated && !this.useSignatureProfile && this.signatureProfiles.length === 0 && (this.credentialsWithCentralKeyToo.length === 1)) {
      this.$nextTick(() => {
        this.selectedCredential = this.findCredentialById(-1)
      })
    }
  },

  methods: {
    async initVisibleSignatureComponents() {
      this.refreshSignatureProfileMap()
      this.chainsToSign.forEach((chain, index) => {
        const signature = this.$refs.visibleSignature[index]
        this.visibleSignatures.push(signature)
        // Initially hide all visibleSignatures
        signature.$el.style.display = 'none'
        this.$set(signature, 'signProf', this.signatureProfileByChainId[chain.id] || this.selectedSignatureProfile)
      })
      this.visibleSignatureCoponentsFilled = true
    },
    async updateSignatureProfileForVisibleSignatureComponents() {
      this.refreshSignatureProfileMap()
      this.chainsToSign.forEach((chain, index) => {
        const signature = this.$refs.visibleSignature[index]
        this.$set(signature, 'signProf', this.signatureProfileByChainId[chain.id] || this.selectedSignatureProfile)
      })
    },
    async saveImagePosToProfileAndApplyAll() {
      await this.saveImagePosToProfile()
      this.applyProfileToAll()
    },
    async saveImagePosToProfile() {
      try {
        // this.defaultPosition = JSON.parse(JSON.stringify(this.selectedSignatureProfile.savedSignatureFieldParameters))

        const profileNeedToSaveOriginal = this.originalSignatureProfiles.find(obj => obj.id === this.selectedSignatureProfile.id)
        const profileNeedToSave = this.getObjectDuplicate(profileNeedToSaveOriginal)

        const activeIndex = this.chainsToSign.findIndex(chain => chain.id === this.currentChain.id)
        if (activeIndex !== -1 && this.visibleSignatures[activeIndex]) {
          const activeSignature = this.visibleSignatures[activeIndex]
          const usedSignatureFieldParameters = activeSignature.getSignatureFieldParameters()
          if (this.useSignatureProfile && usedSignatureFieldParameters) {
            this.$set(this.selectedSignatureProfile, 'savedSignatureFieldParameters', { ...usedSignatureFieldParameters })
            this.$set(profileNeedToSave, 'savedSignatureFieldParameters', { ...usedSignatureFieldParameters })
          }
        }
        // profileNeedToSave.savedSignatureFieldParameters.page = 1
        await signatureProfiles.updateMySignatureProfile(profileNeedToSave.id, profileNeedToSave)
        this.saveImagePostionIcon = 'mdi-content-save-check-outline'
      } catch (error) {
        console.error(error)
      }
    },
    checkUniquePosition(toCheckChain) {
      if (!this.selectedSignatureProfile?.id) return false
      const p = this.selectedSignatureProfile.savedSignatureFieldParameters ? this.getObjectDuplicate(this.selectedSignatureProfile.savedSignatureFieldParameters) : null

      const actualParams = this.getChainSignatureParams(toCheckChain)
      if (actualParams) {
        // const isInDefaultPos = p.originX === actualParams?.originX && p?.originY === actualParams?.originY && p.page === actualParams?.page
        const isInDefaultPos = p?.originX === actualParams.originX && p?.originY === actualParams.originY && (p?.page ? p?.page : 1) === actualParams.page
        return !isInDefaultPos
      }
      // const isInDefaultPos = p.originX === chain.signatureFieldParameters?.savedSignatureFieldParameters?.originX &&
      // p?.originY === chain.signatureFieldParameters?.savedSignatureFieldParameters?.originY
      return false
    },
    applyProfileToAll() {
      const arr = []
      this.chainsToSign.forEach(x => {
        const profile = this.buildSignatureProfileForChain(x)
        x.signatureFieldParameters = this.getObjectDuplicate(profile)
        arr.push(x)
      })
      this.refreshSignatureProfileMap()
      this.chainsToSign.forEach((chain, index) => {
        const signature = this.$refs.visibleSignature[index]
        this.$set(signature, 'signProf', this.signatureProfileByChainId[chain.id] || this.selectedSignatureProfile)
      })

      this.$store.commit('setChainsToSign', arr)
    },
    saveImagePosToDocument() {
      const profile = this.getObjectDuplicate(this.selectedSignatureProfile)
      const arr = this.chainsToSign
      const idx = this.chainsToSign.findIndex(x => x.id === this.currentChain.id)

      this.chainsToSign[idx].signatureFieldParameters = { ...profile }
      this.chainsToSign[idx].id = this.currentChain.id

      this.$store.commit('setChainsToSign', this.chainsToSign)
      this.$forceUpdate()
    },

    async downloadDocument(chain) {
      this.isUploading = true
      try {
        const blob = await documents.downloadDocument(chain.origDocument.id)
        const docuDto = await documents.getDocument(chain.origDocument.id)
        this.currentDocument = docuDto

        const foundDto = this.documenDtos.find(docDto => docDto.id === docuDto.id)
        if (!foundDto) {
          this.documenDtos.push(docuDto)
        }

        const base64 = await this.blobToBase64(blob)
        // this.documentBase64 = base64.split(',')[1]
        return base64.split(',')[1]
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
        return null
      } finally {
        // this.isUploading = false
      }
    },

    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },

    selectFirstProfile() {
      if (this.signatureProfiles.length > 0) {
        this.useSignatureProfile = true
        this.selectedSignatureProfile = this.signatureProfiles[0]
      }
    },

    async getSignatureProfiles() {
      try {
        this.signatureProfiles = await signatureProfiles.getSignatureProfiles()
        this.originalSignatureProfiles = this.getObjectDuplicate(this.signatureProfiles)

        this.signatureProfiles.forEach(profile => {
          delete profile.textParams
          // deleting the sourceImageDataUrl here, because we will use the dynamically rendered image later, when profile first selected
          delete profile.sourceImageDataUrl
        })

        if (this.signatureProfiles.length === 0) {
          this.useSignatureProfile = false
        }

        this.signatureProfilesFilled = true
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async listMyActivatedCredentials() {
      try {
        const resp = await rssp.listMyActivatedCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN') && (elem.certChain.length > 0)))

        this.activatedCredentials = resp.content
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },
    async listImportedCredentials() {
      try {
        const pageRequestImported = {
          'page-num': 1,
          'page-size': 50,
          'sort-field': 'user.name',
          'sort-order': 'desc'
        }

        const pageImported = await credentialRefs.listCredentialRefs(this.user.id, null, pageRequestImported)
        if (this.evroEnabled) {
          const pageEvroImported = await evro.listEvroRefs(this.user.id, null, pageRequestImported)
          pageEvroImported.content = pageEvroImported.content.map(item => {
            return {
              ...item,
              isEvro: true
            }
          })
          this.credentialsEvro = pageEvroImported.content
        }
        this.credentialRefs = pageImported.content
        this.haveImportedcontent = (pageImported.content.length > 0) || (this.credentialsEvro.length > 0)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },
    async handleWarning() {
      try {
        const resp = await rssp.listMyCredentials()
        resp.content = resp.content.filter(elem => ((elem.keyPurpose === 'ASYMMETRIC_SIGN')))
        this.myCredentials = resp.content

        const devices = await rssp.listMyDevices()
        this.devicesListTotalItems = devices.total

        const credentialActivatedImplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'IMPLICIT').length
        const credentialActivatedExplicitTotalItems = this.activatedCredentials.filter(x => x.authMode === 'EXPLICIT').length
        const credentialImplicitTotalItems = this.myCredentials.filter(x => x.authMode === 'IMPLICIT').length
        this.devicesActiveTotalItems = devices.content.filter(x => x.enabled === true).length

        if (!this.sealEnabled) {
          this.noDeviceForImplicitCredentialWarningVisible = (credentialActivatedExplicitTotalItems === 0) && (this.devicesListTotalItems === 0) && (credentialImplicitTotalItems > 0)
          this.noCredentialWarningVisible = !this.noDeviceForImplicitCredentialWarningVisible && (this.activatedCredentials.length === 0) && (this.credentialsEvro.length === 0)
          this.showBlueWarning = (this.myCredentials.filter(x => x.status !== 'ACTIVATED' || x.certChain.length === 0).length > 0) || (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0)
          if (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems > 0 && this.devicesActiveTotalItems === 0) {
            this.showBlueWarning = true
          }
        } else {
          this.noDeviceForImplicitCredentialWarningVisible = (credentialActivatedExplicitTotalItems === 0) && (this.devicesListTotalItems === 0) && (credentialImplicitTotalItems > 0)
          this.showBlueWarning = !this.sealActivated && ((this.myCredentials.filter(x => x.status !== 'ACTIVATED' || x.certChain.length === 0).length > 0) || (credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems === 0))
          if (!this.sealActivated && credentialActivatedImplicitTotalItems > 0 && this.devicesListTotalItems > 0 && this.devicesActiveTotalItems === 0) {
            this.showBlueWarning = true
          }
        }
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    updatedSignatureProfile(variable) {
      this.dragging = true
      // this.selectedSignatureProfile = variable
      if (!this.signatureProfileMoved) this.signatureProfileMoved = true
    },

    getObjectDuplicate(obj) {
      try {
        return JSON.parse(JSON.stringify(obj))
      } catch {
        // console.log('BUG, this.selectedSignatureProfile', this.selectedSignatureProfile, this.credentialsWithCentralKeyToo)
        return null
      }
    },

    pdfLoaded(variable) {
      this.pdfRendered = true
      this.isUploading = false
      this.dragging = false

      // selecting profile when only one is active with seal enabled mode
      if (!this.initialProfileAlreadySelected && this.sealActivated && this.activatedCredentials.length === 0 && this.credentialRefs.length === 0 && this.credentialsEvro.length === 0 && this.signatureProfiles.length === 1) {
        this.initialProfileAlreadySelected = true
        this.useSignatureProfile = true

        this.signatureProfileBackup = JSON.parse(JSON.stringify(this.signatureProfiles[0]))

        this.$nextTick(() => {
          // avoid corrupt profile load
          if (this.signatureProfileBackup && this.signatureProfileBackup.id) {
            this.selectedSignatureProfile = JSON.parse(JSON.stringify(this.signatureProfileBackup))
          }
          // this.selectedSignatureProfile = JSON.parse(JSON.stringify(this.signatureProfileBackup))
        })
      }

      if (!this.selectedCredential) {
        this.selectedCredential = {}
      }
      if (this.useSignatureProfile && this.selectedSignatureProfile && (this.selectedSignatureProfile.credentialRefId || this.selectedSignatureProfile.evroRefId || this.selectedSignatureProfile.credentialId)) {
        // this.selectedCredential.id = this.selectedSignatureProfile.credentialRefId ? this.selectedSignatureProfile.credentialRefId : parseInt(this.selectedSignatureProfile.credentialId)
        if (this.selectedSignatureProfile.credentialRefId) {
          this.selectedCredential = this.getObjectDuplicate(this.findCredentialByRefId(parseInt(this.selectedSignatureProfile.credentialRefId)))
        } else
        if (this.selectedSignatureProfile.evroRefId) {
          this.selectedCredential = this.getObjectDuplicate(this.findCredentialByEvroRefId(parseInt(this.selectedSignatureProfile.evroRefId)))
        } else {
          this.selectedCredential = this.getObjectDuplicate(this.findCredentialById(parseInt(this.selectedSignatureProfile.credentialId)))
        }
      }

      const activeIndex = this.chainsToSign.findIndex(chain => chain.id === this.currentChain.id)
      if (activeIndex !== -1 && this.visibleSignatures[activeIndex]) {
        const activeSignature = this.visibleSignatures[activeIndex]
        if (!activeSignature.isFabricControlsInited()) {
          activeSignature.redrawEverything()
        }
      }

      this.checkFormValidity()
    },

    showAuthorizationModal() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.authorizationModal = true
      this.$nextTick(() => {
        this.$refs.authorizationModalForm.reset()
        this.$nextTick(() => {
          this.$refs.passwordField.focus()
        })
      })
    },

    async showDeclineModal(e) {
      const opts = {
        title: this.$t('dialog.confirmation.title'),
        posX: e.clientX,
        posY: e.clientY
      }
      const conf = await showConfirmationMenu(opts)
      if (!conf) {
        return
      }
      this.declineReasonVisible = true
    },
    getCurrentProvider() {
      return this.providers.find(provider => provider.id === this.selectedCredential.provider)
    },

    getExternalProviderRDSSBaseURL(providerId) {
      return this.$store.state.remoteConfig.rdssApiUrl + '/v1/extproviders/' + providerId
    },

    handleCSCErrorMessage(error) {
      if (error.message) {
        return this.$t('toastMessage.errorDuringPopupLoginWithDetails', { msg: error.message })
      } else {
        return this.$t('toastMessage.errorDuringPopupLogin')
      }
    },

    async getCredentialInfosWithCSC() {
      const foundProvider = this.getCurrentProvider()
      const usedOIDC = foundProvider.oidc
      let providerBaseURL

      if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
        providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
      } else {
        providerBaseURL = foundProvider.apiBaseUrl
      }

      if (!this.selectedCredential.idToken) {
        let oldIdToken = null
        if (foundProvider.id === this.$popupAuth.settings.providerId) {
          const user = await this.$popupAuth.getUser()
          try {
            oldIdToken = user ? await this.$popupAuth.getIdToken() : null
            // this.id_token = user ? user.id_token : null
            if (user && !oldIdToken) {
              // this.id_token = user.access_token
              oldIdToken = await this.$popupAuth.getAccessToken()
            }
          } catch (Err) {
            oldIdToken = null
          }
        }
        if (oldIdToken && (foundProvider.id === this.$popupAuth.settings.providerId)) {
          this.selectedCredential.idToken = oldIdToken
        } else {
          const settings = {
            authority: usedOIDC.issuer,
            apiBaseUrl: providerBaseURL,
            providerId: foundProvider.id,
            client_id: usedOIDC.clientId,
            response_type: 'code',
            scope: usedOIDC.scope,
            prompt: usedOIDC.prompt,
            monitorSession: false,
            // popupWindowFeatures: `location=no,toolbar=no,width=${this.popupLoginWidth},height=${this.popupLoginHeight},left=100,top=100`
            popupWindowFeatures: {
              location: false,
              menubar: false,
              toolbar: false,
              height: this.popupLoginHeight,
              width: this.popupLoginWidth,
              closePopupWindowAfterInSeconds: -1
            }
          }
          if (usedOIDC.clientSecret) {
            settings.client_secret = usedOIDC.clientSecret
          }

          if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
            settings.metadata = {
              authorization_endpoint: usedOIDC.authorizationEndpoint,
              // token_endpoint: usedOIDC.tokenEndpoint,
              token_endpoint: providerBaseURL + '/openid/token',
              revocation_endpoint: usedOIDC.revocationEndpoint
            }
          }
          this.$popupAuth.setSettings(settings)
          try {
            const user = await this.$popupAuth.login()
            this.selectedCredential.idToken = user.access_token
            if (!user.id_token) {
              this.selectedCredential.idToken = user.access_token
            } else {
              this.selectedCredential.idToken = user.id_token
            }
          } catch (error) {
            console.error('An error occured during login.', error)
            showToastError(this.handleCSCErrorMessage(error))
            return null
          }
        }
      }

      if (!this.selectedCredential.idToken) {
        showToastError(this.$t('importCredential.loginError'))
        return null
      } else {
        const req = {
          // credentialID: this.selectedCredential.credentialId ? parseInt(this.selectedCredential.credentialId) : parseInt(this.selectedCredential.id)
          credentialID: this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id
          /*,
          certInfo: null,
          certificates: 'none' */
        }
        const resp = await csc.credentialsInfo(providerBaseURL, this.selectedCredential.idToken, req)
        this.selectedCredential.authMode = resp.authMode.toUpperCase()

        this.selectedCredential.cert = resp.cert
        this.selectedCredential.providerBaseURL = providerBaseURL
        return resp
      }
    },

    isChainHaveSignature(item) {
      return item.signedDocument !== undefined && item.signedDocument.id !== undefined
    },

    showPasswordModal() {
      this.isPasswordModalVisible = true
      return new Promise((resolve, reject) => {
        this.passwordModalResolve = resolve
        this.passwordModalReject = reject
      })
    },

    async getPDFPassword(pdfFilename) {
      try {
        this.pdfFilename = pdfFilename
        const givenPassword = await this.showPasswordModal()
        return givenPassword
      } catch (error) {
        return null
      }
    },
    handlePasswordSpecified(password) {
      this.isPasswordModalVisible = false
      if (this.passwordModalResolve) {
        this.passwordModalResolve(password)
      }
    },
    handlePasswordCancelled() {
      this.isPasswordModalVisible = false
      if (this.passwordModalReject) {
        this.passwordModalReject()
      }
    },

    extractDocHashes(jsonArray) {
      return jsonArray.map(item => item.docHash)
    },

    updateDocHashes(targetObj, docHashes) {
      let chunkSize = 0
      let startIdx = 0
      for (let i = 0; i < targetObj.signatures.length; i++) {
        const chain = this.findChainBySignatureId(this.chainsToSign, targetObj.signatures[i].signatureId)
        if (chain.signingTrailMode) {
          if (chain.signingTrailMode === 'ATTACHED') {
            chunkSize = 1
          } else
          if (chain.signingTrailMode === 'DETACHED') {
            chunkSize = 2
          } else {
            chunkSize = 1
          }
        } else {
          chunkSize = 1
        }
        targetObj.signatures[i].docHashes = docHashes.slice(startIdx, startIdx + chunkSize)
        startIdx = startIdx + chunkSize
      }
    },

    calculateChunkSize(chain) {
      if (chain.signingTrailMode) {
        if (chain.signingTrailMode === 'ATTACHED') {
          return 1
        } else
        if (chain.signingTrailMode === 'DETACHED') {
          return 2
        } else {
          return 1
        }
      } else {
        return 1
      }
    },

    async signDoc() {
      const isSealSignMode = this.isSealSignMode()
      if (this.selectedCredential === undefined || !this.selectedCredential) {
        this.selectedCredential = {}
      }
      // this should never happen normally, but in case of rare error, we try to fix the credential id
      if (this.selectedCredential && isNaN(this.selectedCredential.id)) {
        if ((this.selectedCredential.isEvro) && this.useSignatureProfile && this.selectedSignatureProfile) {
          this.selectedCredential.id = this.selectedSignatureProfile.evroRefId
        } else
        if ((this.selectedCredential.provider) && this.useSignatureProfile && this.selectedSignatureProfile) {
          this.selectedCredential.id = this.selectedSignatureProfile.credentialRefId
        } else {
          this.selectedCredential.id = this.selectedSignatureProfile.credentialId
        }
      }

      const credentialRefId = this.selectedCredential?.provider ? this.selectedCredential.id : undefined
      const evroRefId = this.selectedCredential?.isEvro ? this.selectedCredential.id : undefined

      if (this.selectedCredential && this.selectedCredential.provider && credentialRefId && !this.selectedCredential.idToken) {
        await this.getCredentialInfosWithCSC()
        if (!this.selectedCredential.idToken) {
          return
        }
      }
      /* if (!isSealSignMode && (!this.selectedCredential.certChain || this.selectedCredential.certChain.length === 0)) {
        showToastError(this.$t('documentSignatureCustomization.content.signature.noCertificateError'))
        return
      } */
      if (!isSealSignMode) {
        if (this.selectedCredential) {
          let certChainOK = true
          if (this.selectedCredential && (this.selectedCredential.id !== -1)) {
            if (this.selectedCredential.isEvro && (!this.selectedCredential.certificatePem || this.selectedCredential.certificatePem.length === 0)) {
              certChainOK = false
            }
            if (!this.selectedCredential.provider && !this.selectedCredential.isEvro && (!this.selectedCredential.certChain || this.selectedCredential.certChain.length === 0)) {
              certChainOK = false
            }
            if (this.selectedCredential.provider && (!this.selectedCredential.cert || this.selectedCredential.cert.certificates.length === 0)) {
              certChainOK = false
            }
          }

          if (this.selectedCredential && !certChainOK) {
            showToastError(this.$t('documentSignatureCustomization.content.signature.noCertificateError'))
            return
          }

          if (this.useSignatureProfile && this.selectedSignatureProfile) {
            const profileCredFoundInActivated = !!(this.activatedCredentials.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            const profileCredFoundInImported = !!(this.credentialRefs.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            const profileCredFoundInEvro = !!(this.credentialsEvro.find(cred => cred.id === parseInt(this.selectedCredential.id)))
            if (!profileCredFoundInActivated && !profileCredFoundInImported && !profileCredFoundInEvro) {
              showToastError(this.$t('validation.form.credentialIsDead'))
              return
            }
          }
        }
      }

      this.isUploading = true
      const explicitCredential = !isSealSignMode && this.isExplicitCredential(this.selectedCredential)
      const implicitCredential = !isSealSignMode && this.isImplicitCredential(this.selectedCredential)

      if (implicitCredential && this.devicesListTotalItems === 0) {
        this.isUploading = false
        showToastError(this.$t('documentSignatureCustomization.content.signature.activeCredentialButNoActivatedDeviceError'))
        return
      }

      const OAUTH2CODECredential = this.isOAUTH2CODECredential(this.selectedCredential)

      if (implicitCredential || evroRefId) {
        this.implicitGuid = uuidv4()
      }

      this.evroSignatureCount = 0
      let chainSequence = Promise.resolve()
      let cancelled = false
      this.chainsToSign.forEach((chain, index) => {
        chainSequence = chainSequence.then(async () => {
          if (cancelled) {
            return
          }
          let documenDto = this.documenDtos.find(docDto => docDto.id === chain.origDocument.id)
          if (!documenDto) {
            documenDto = await documents.getDocument(chain.origDocument.id)
            this.documenDtos.push(documenDto)
          }

          const isEncryptedWithPassword = (documenDto.security === 'ENCRYPTED_WITH_OWNER_PASSWORD') || (documenDto.security === 'ENCRYPTED_WITH_USER_PASSWORD')
          const activeSignature = this.visibleSignatures[index]
          activeSignature.updateEncryptionStatus(isEncryptedWithPassword)
          if (isEncryptedWithPassword) {
            const pdfPasswordModalComponent = this.$refs.pdfPasswordModal
            pdfPasswordModalComponent.resetPassword()
            const passwordSpecified = await this.getPDFPassword(documenDto.fileName)
            if (passwordSpecified === null) {
              this.isUploading = false
              cancelled = true
              return
            }
            activeSignature.setPassword(passwordSpecified)
          }
          if (evroRefId) {
            const chunkSize = this.calculateChunkSize(chain)
            this.evroSignatureCount += chunkSize
          }
        })
      })
      await chainSequence
      if (cancelled) {
        return
      }

      this.authorizationModalBtnLoading = explicitCredential

      try {
        const signRequest = {
          useSeal: isSealSignMode
        }

        if (!isSealSignMode) {
          const credentialOptions = {
            description: this.implicitGuid
          }
          if (credentialRefId) {
            this.$set(credentialOptions, 'credentialRefId', credentialRefId)
            this.$set(credentialOptions, 'authentication', this.selectedCredential.idToken)
          } else
          if (evroRefId) {
            this.$set(credentialOptions, 'evroRefId', evroRefId)
          } else {
            if (this.selectedCredential.id) {
              this.$set(credentialOptions, 'credentialId', this.selectedCredential.id)
            }
          }

          if (explicitCredential) {
            this.$set(credentialOptions, 'PIN', this.expAuthPwd.pwd)
          }
          this.$set(signRequest, 'credentialOptions', credentialOptions)
        }

        const documentsOptions = []

        let activeIndex = 0
        this.chainsToSign.forEach(chain => {
          const activeSignature = this.visibleSignatures[activeIndex]
          const encrypted = activeSignature.getEncrypted()
          const pdfPassword = activeSignature.getPassword()
          if (encrypted && pdfPassword) {
            let usedDocId
            if (chain.signatures) {
              const elem = chain.signatures.findLast(this.isChainHaveSignature)
              usedDocId = elem ? elem.signedDocument.id : chain.origDocument.id
            } else {
              usedDocId = chain.origDocument.id
            }
            const documentsOption = {
              docId: usedDocId,
              passwordProtection: pdfPassword
            }
            documentsOptions.push(documentsOption)
          }
          activeIndex++
        })
        if (documentsOptions.length > 0) {
          this.$set(signRequest, 'documentsOptions', documentsOptions)
        }

        const signaturesList = []

        if (this.useVisibleSignature) {
          if (this.useSignatureProfile && this.selectedSignatureProfile) {
            this.$set(signRequest, 'signatureProfileId', this.selectedSignatureProfile.id)
          } else
          if (this.userDrawedSignatureImage) {
            this.$set(signRequest, 'userImageDataUrl', this.userDrawedSignatureImage)
          }

          let index = 0
          this.chainsToSign.forEach(chain => {
            const signature = {
              signatureId: this.getSignatureId(chain),
              currentSignatureId: this.getCurrentSignatureId(chain) || undefined
            }
            const visibleSignature = this.$refs.visibleSignature[index]
            let usedSignatureFieldParameters = visibleSignature.getSignatureFieldParameters()
            if (!usedSignatureFieldParameters) {
              usedSignatureFieldParameters = this.selectedSignatureProfile.savedSignatureFieldParameters
            }
            if (usedSignatureFieldParameters) {
              this.$set(signature, 'signatureFieldParameters', { ...usedSignatureFieldParameters })
            }

            if (signature.signatureFieldParameters) {
              delete signature.signatureFieldParameters.sourceImageDataUrl
              delete signature.signatureFieldParameters.renderedImageDataUrl
            }

            signaturesList.push(signature)
            index++
          })
        } else {
          let index = 0
          this.chainsToSign.forEach(chain => {
            const signature = {
              signatureId: this.getSignatureId(chain),
              currentSignatureId: this.getCurrentSignatureId(chain) || undefined
            }
            signaturesList.push(signature)
            index++
          })
        }

        this.$set(signRequest, 'signatures', signaturesList)

        try {
          if (implicitCredential || evroRefId) {
            this.implicitAuthorizationModalKey++
            this.ImplicitAuthorizationModalVisible = true
          }
          let providerAuthorizationTimeoutMilis
          let foundProvider
          if (this.selectedCredential && this.selectedCredential.provider) {
            foundProvider = this.getCurrentProvider()
            providerAuthorizationTimeoutMilis = foundProvider.authorizationTimeoutSecs ? foundProvider.authorizationTimeoutSecs * 1000 : 0
          }
          const usedAuthorizationTimeoutSecs = (this.selectedCredential && this.selectedCredential.isEvro) ? this.evroTrustAuthorizationTimeoutMilis : ((this.selectedCredential && this.selectedCredential.provider) ? providerAuthorizationTimeoutMilis : this.authorizationTimeoutMilis)
          if (OAUTH2CODECredential) {
            this.$set(signRequest, 'returnHashes', true)
          }
          const sign1Resp = await signatures.sign(signRequest, (implicitCredential || evroRefId) ? usedAuthorizationTimeoutSecs : null)

          if (OAUTH2CODECredential) {
            let sad
            const docHashes = this.extractDocHashes(sign1Resp)

            if (foundProvider) {
              this.$set(signRequest, 'returnHashes', true)
              const url = window.location.origin
              const settings = {
                authority: foundProvider.oidc.issuer,
                client_id: foundProvider.oidc.clientId,
                popup_redirect_uri: `${url}/popup-callback`,
                response_type: 'code',
                scope: 'credential',
                prompt: foundProvider.oidc.prompt,
                monitorSession: false,
                popupWindowFeatures: {
                  location: false,
                  menubar: false,
                  toolbar: false,
                  height: this.popupLoginHeight,
                  width: this.popupLoginWidth,
                  closePopupWindowAfterInSeconds: -1
                }
              }
              if (foundProvider.oidc.clientSecret) {
                settings.client_secret = foundProvider.oidc.clientSecret
              }
              let providerBaseURL
              if (foundProvider.oidc.authorizationEndpoint && foundProvider.oidc.tokenEndpoint && foundProvider.oidc.revocationEndpoint) {
                providerBaseURL = this.getExternalProviderRDSSBaseURL(foundProvider.id)
                settings.metadata = {
                  authorization_endpoint: foundProvider.oidc.authorizationEndpoint,
                  // token_endpoint: usedOIDC.tokenEndpoint,
                  token_endpoint: providerBaseURL + '/openid/token',
                  revocation_endpoint: foundProvider.oidc.revocationEndpoint
                }
                settings.extraQueryParams = {
                  numSignatures: docHashes.length,
                  credentialID: this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id,
                  hash: docHashes,
                  description: 'Please allow RSSP to sign with your key!'
                }
              } else {
                providerBaseURL = foundProvider.apiBaseUrl
              }
              const mgr = new UserManager(settings)
              try {
                const user = await mgr.signinPopup()
                if (user.token_type === 'SAD') {
                  sad = user.access_token
                } else {
                  if (!user.id_token) {
                    this.selectedCredential.idToken = user.access_token
                  } else {
                    this.selectedCredential.idToken = user.id_token
                  }
                  sad = user.sad
                }
              } catch (error) {
                console.error('An error occured during login.', error)
                showToastError(this.handleCSCErrorMessage(error))
                return
              }
            } else {
              const authorizeCredentialRequest = {
                numSignatures: docHashes.length,
                hash: docHashes
              }
              this.$set(authorizeCredentialRequest, 'credentialID', this.selectedCredential.credentialId ? this.selectedCredential.credentialId : this.selectedCredential.id)
              if (explicitCredential) {
                this.$set(authorizeCredentialRequest, 'PIN', this.expAuthPwd.pwd)
              }

              const authorizeCredentialResp = await csc.authorizeCredential(this.selectedCredential.providerBaseURL, this.selectedCredential.idToken, authorizeCredentialRequest)
              sad = authorizeCredentialResp.SAD
            }
            this.$set(signRequest, 'returnHashes', false)
            this.$set(signRequest, 'sad', sad)
            // this.$set(signRequest, 'signatures', signaturesList)
            this.updateDocHashes(signRequest, docHashes)
            const sign2Resp = await signatures.sign(signRequest, implicitCredential ? usedAuthorizationTimeoutSecs : null)
          }

          this.back()
          showToastSuccess(this.$t('toastMessage.succesfullySigned'))
        } catch (error) {
          if (error?.response?.data?.code === CommonError.SERVICE_UNAVAILABLE) {
            showToastError(this.$t('documentSignatureCustomization.content.signature.toastMessages.sicAborted'))
          } else {
            const errorMsg = this.getErrorMessage(error)
            showToastError(errorMsg)
          }
        }
      } catch (error2) {
        console.error('signDoc, exception occured', error2)
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.authorizationModalBtnLoading = false
        this.ImplicitAuthorizationModalVisible = false
        this.authorizationModal = false
        this.isUploading = false
      }
    },

    isExplicitCredential(credential) {
      return credential && (credential.authMode === CredentialAuthMode.EXPLICIT)
    },

    isImplicitCredential(credential) {
      return credential && (credential.authMode === CredentialAuthMode.IMPLICIT)
    },

    isOAUTH2CODECredential(credential) {
      return credential && (credential.authMode === 'OAUTH2CODE')
    },

    isCredentialUnknownAuthMode(credential) {
      return credential && (!credential.authMode)
    },

    isSealSignMode() {
      const res = (!!(this.sealActivated && ((this.activatedCredentials.length === 0 && this.credentialRefs.length === 0 && this.credentialsEvro.length === 0) ||
        (this.useSignatureProfile && this.selectedSignatureProfile && this.selectedSignatureProfile.useSeal && !this.useDifferentCredential) ||
        (this.selectedCredential && this.selectedCredential.id && this.selectedCredential.id === this.centralKeyId))))
      return res
    },

    back() {
      this.declineReasonVisible = false
      this.$router.push({ name: 'SignatureChains' })
    },

    checkFormValidity() {
      // Check if the form is valid
      if (this.$refs.form.validate()) {
        this.formValid = true
        // console.log('checkFormValidity form validation true')
      } else {
        // console.log('checkFormValidity form validation false')
        // this.logValidationErrors()
      }
    },
    logValidationErrors() {
      // Check if errorBag exists and is an object
      if (this.$refs.form.errorBag && typeof this.$refs.form.errorBag === 'object') {
        // Iterate through errorBag and log error messages and rules
        for (const fieldName in this.$refs.form.errorBag) {
          const fieldErrors = this.$refs.form.errorBag[fieldName]
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(error => {
              console.error(error)
            })
          } else if (typeof fieldErrors === 'string') {
            console.error(`Field: ${fieldName}, Error Message: ${fieldErrors}`)
          } else {
            // Handle if fieldErrors is not an array or string
            console.error(`Unexpected errorBag structure for field ${fieldName}:`, fieldErrors)
          }
        }
      } else {
        console.error('ErrorBag is not properly defined or is not an object')
      }
    },
    handleFormValidityChange(valid) {
      // valid parameter indicates whether the form is valid or not
      if (!valid) {
        // Additional actions you may want to take when a validation error occurs
        // this.logValidationErrors()
      }
    },
    findChainBySignatureId(chains, signatureId) {
      return chains.find(chain =>
        chain.signatures.some(signature => signature.id === signatureId)
      )
    },

    getSignatureId(chain) {
      const userSignature = chain.signatures.find(signature => ((signature.user.id === this.currentUser.id) && (signature.status === 'CREATED')))
      return userSignature?.id || undefined
    },
    getCurrentSignatureId(chain) {
      let currentSignatureId

      if (chain.type !== SignatureChainType.ORDERED && chain.currentSignatureId !== undefined) {
        currentSignatureId = chain.currentSignatureId
      }

      return currentSignatureId
    },

    signatureDropped() {
      this.dragging = false
      // this.saveImagePosToDocument()
    },

    pageChanged() {
      this.dragging = false
    },
    async getVerificationDetails() {
      try {
        /* const req = {
          transactionId: 'a3ca2b6d-b28e-442c-86d4-394e41d13a6d',
          processParam: {
            scenario: 'FullAuth'
          }
        }
        await userVerification.processRegula(req) */
        this.userVerificationStatus = await userVerification.getUserVerificationStatus()
        this.userVerified = this.userVerificationStatus.verified
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },
    findCredentialByRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (item.provider && parseInt(item.id) === searchId))
      return matchingCredential
    },
    findCredentialByEvroRefId(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (item.isEvro && parseInt(item.id) === searchId))
      return matchingCredential
    },
    findCredentialById(searchId) {
      const matchingCredential = this.credentialsWithCentralKeyToo.find(item => (!item.provider && !item.isEvro && parseInt(item.id) === searchId))
      return matchingCredential
    },
    getCredentialItemText(item) {
      if (item.provider) {
        return `${item.description} | external: ${item.provider}`
      } else {
        if (item.isEvro) {
          return `${item.description} | evrotrust`
        } else {
          return item.description
        }
      }
    },
    openSignatureModal() {
      this.$refs.signatureDrawer.dialog = true
    },
    async handleCustomSignature(imageData) {
      if (!this.selectedSignatureProfile) {
        this.selectedSignatureProfile = {}
      }

      this.userDrawedSignatureImage = imageData
      this.useCustomDrawnSignatureImage = true

      const req = {
        userImageDataUrl: imageData,
        subsignerName: null
      }

      const mergedBase64 = await signatures.combineImage(req)
      this.selectedSignatureProfile.sourceImageDataUrl = mergedBase64.imageDataUrl

      this.refreshSignatureProfileMap()
      this.chainsToSign.forEach((chain, index) => {
        const signature = this.$refs.visibleSignature[index]
        signature.updateSignatureProfile(this.signatureProfileByChainId[chain.id] || this.selectedSignatureProfile)
      })
    },
    setSignatureImage(file, imageDataUri, callPreview = true) {
      let updatedDataUri = ''
      const splittedSigImgDataUrl = imageDataUri.split(';')
      updatedDataUri = updatedDataUri.concat(splittedSigImgDataUrl[0], ';filename=' + file.name + ';', splittedSigImgDataUrl[1])
      this.$set(this.signatureProfile, 'sourceImageDataUrl', updatedDataUri)
      if (callPreview) {
        this.initPreview()
      }
    },
    handleCustomSignatureCancelled() {
      this.useSignatureProfile = true
      this.clearCutomSignatureImageClick()
    },

    useCustomSignatureClick() {
      this.useSignatureProfile = false
      // this.useCustomDrawnSignatureImage = true
      this.openSignatureModal()
    },
    useSignatureProfileClick() {
      this.useCustomDrawnSignatureImage = false
      this.useSignatureProfile = true
    },
    clearCutomSignatureImageClick() {
      this.useCustomDrawnSignatureImage = false
      this.userDrawedSignatureImage = null
      if (this.selectedSignatureProfile) {
        this.selectedSignatureProfile.sourceImageDataUrl = undefined
        this.$nextTick(() => {
          this.refreshSignatureProfileMap()
          this.chainsToSign.forEach((chain, index) => {
            const signature = this.$refs.visibleSignature[index]
            signature.updateSignatureProfile(this.signatureProfileByChainId[chain.id] || this.selectedSignatureProfile)
          })
        })
      }
      this.useSignatureProfile = false
      this.selectFirstProfile()
    },
    getCurrentUserSignature(chain) {
      if (!chain || !Array.isArray(chain.signatures)) return null
      return chain.signatures.find(
        signature =>
          signature.user?.id === this.currentUser?.id &&
          signature.status === 'CREATED'
      )
    },
    getPredefinedSignatureParams(chain) {
      const params = this.getCurrentUserSignature(chain)?.signatureFieldParameters
      if (!params) return null

      const { originX, originY, width, height, page } = params
      if ([originX, originY, width, height, page].some(v => v === undefined || v === null)) {
        return null
      }

      const parsed = {
        originX: parseFloat(originX),
        originY: parseFloat(originY),
        width: parseFloat(width),
        height: parseFloat(height),
        page: parseInt(page)
      }

      const isValid =
        !isNaN(parsed.originX) &&
        !isNaN(parsed.originY) &&
        !isNaN(parsed.width) &&
        !isNaN(parsed.height) &&
        !isNaN(parsed.page)

      return isValid ? parsed : null
    },
    hasPredefinedSignatureParams(chain) {
      return !!this.getPredefinedSignatureParams(chain)
    },
    buildSignatureProfileForChain(chain, baseProfileOverride = null) {
      const baseProfile = this.getObjectDuplicate(baseProfileOverride || this.selectedSignatureProfile) || {}
      const predefined = this.getPredefinedSignatureParams(chain)
      if (predefined) {
        baseProfile.savedSignatureFieldParameters = { ...predefined }
      }
      return baseProfile
    },
    getChainSignatureParams(chain) {
      if (!chain) return null
      const activeIndex = this.chainsToSign.findIndex(c => c.id === chain.id)
      if (activeIndex !== -1 && this.visibleSignatures[activeIndex]) {
        const liveParams = this.visibleSignatures[activeIndex].getSignatureFieldParameters()
        if (liveParams) return liveParams
      }
      const stored = this.signatureProfileByChainId[chain.id]?.savedSignatureFieldParameters
      return stored || null
    },
    refreshSignatureProfileMap() {
      const map = {}
      if (Array.isArray(this.chainsToSign)) {
        this.chainsToSign.forEach(chain => {
          map[chain.id] = this.buildSignatureProfileForChain(chain)
        })
      }
      this.signatureProfileByChainId = map
    }
  }
}
</script>

<style>
.BlueWarning {
  color: var(--v-accent-base);
}
</style>
